export default function validate(values, language) {
  const errors = {};
  errors.media = {};

  const translation = values.translations.find((lang) => lang.langCode === language);
  const isEmptyString = (value) => typeof value !== "string" || value.trim() === "";

  if (isEmptyString(translation?.actionableInsights)) {
    errors.actionableInsights = "Please enter actionable insights.";
  }

  if (isEmptyString(translation?.aboutTheBook)) {
    errors.aboutTheBook = "Please enter about the book.";
  }

  if (isEmptyString(translation?.whyItMatters)) {
    errors.whyItMatters = "Please enter why this book matters.";
  }

  if (
    !translation?.authorName ||
    (typeof translation.authorName === "string" &&
      translation.authorName.trim() === "")
  ) {
    errors.authorName = "Please add author name.";
  }

  if (!translation?.genre || translation.genre.length === 0) {
    errors.genre = "Please add genres.";
  }

  if (isEmptyString(translation?.reflectionQuestions)) {
    errors.reflectionQuestions = "Please enter questions this book forces you to ask.";
  }

  if (isEmptyString(translation?.ideas)) {
    errors.ideas = "Please add some key ideas.";
  }

  if (isEmptyString(translation?.shouldReadFor)) {
    errors.shouldReadFor = "Please specify who should read this book.";
  }

  if (isEmptyString(translation?.curatedQuotes)) {
    errors.curatedQuotes = "Please enter notable quotes.";
  }

  if (
    !translation?.relatedBooks ||
    (typeof translation.relatedBooks === "string" &&
      translation.relatedBooks.trim() === "") ||
    (Array.isArray(translation.relatedBooks) &&
      translation.relatedBooks.length === 0)
  ) {
    errors.relatedBooks = "Please enter related book name.";
  }

  // if (
  //   !translation?.media?.audio ||
  //   Object.keys(translation.media.audio || {}).length === 0 ||
  //   !translation.media.audio.uploadedImageUrl
  // ) {
  //   errors.media.audio = "Please upload an audio file.";
  // }

  // if (
  //   !translation?.media?.video ||
  //   Object.keys(translation.media.video || {}).length === 0 ||
  //   !translation.media.video.uploadedImageUrl
  // ) {
  //   errors.media.video = "Please upload a video file.";
  // }

  if (Object.keys(errors.media).length === 0) {
    delete errors.media;
  }

  if (Object.keys(errors).length > 0) {
    errors.message = "Form validation failed.";
  }

  return errors;
}
